// manually edited

import { Page } from '../components/declarations/Page';

export const pagesConfig: Page[] = [
  // otevira se v novem okne - primo a href v sablone
  {
    title: 'Napište nám',
    url: '/velikonoce2024/napiste-nam',
    uuid: null,
  },
  {
    title: 'Soutěž',
    url: '/velikonoce2024/soutez',
    uuid: null,
  },
  {
    title: 'O projektu',
    url: '/velikonoce2024/o-projektu',
    uuid: null,
  },
];
